// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1KbxV","head":"ProcedureTableInfo_head__2wTAv"};